import React from "react";
import styled from "styled-components";
import { colors, fonts, mediaQueries } from "../shared/config";
const { title, baseText, body } = fonts;

const { mobile, notMobile, tablet } = mediaQueries;

const Container = styled("div")`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  left: 50%;
  text-align: center;
  align-content: center;
  z-index: 1;
`;

const CardLayout = styled("a")`
  width: 27vw;
  height: 320px;
  ${mediaQueries.mobile} {
    width: 75vw;
    height: auto;
    padding-top: 30px;
  }
  text-decoration: none;
  color: ${colors.cardsbg};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2% 0;
`;

const Description = styled("div")`
  width: 100%;
  text-align: center;
  padding: 15px;
  box-sizing: border-box;
  font-size: 12px;
  color: ${colors.black};
  background: ${colors.cardsbg};
`;

const Headline = styled("div")`
  color: #D9A648;
  font-size: 16px;
  width: 100%;
  text-align: left;
  font-family: ${title};
  font-weight: 700;
`;

const MiniText = styled("div")`
  font-size: 14px;
  width: 100%;
  font-family: "Quicksand", sans-serif;
  text-align: left;
`;

const Author = styled("div")`
  font-size: 12px;
  width: 100%;
  line-height: 15px;
  font-weight: 700;
  text-align: left;
  margin-top: 2px;
  font-family: "Quicksand", sans-serif;
`;

const BoxImage = styled("img")`
  width: 100%;
  background: #c4c4c4;
  height: 250px;
  object-fit: cover;
  ${mobile} {
    height: 150px;
  }
`;

export default function Card(props) {
  return (
    <Container>
      <CardLayout href={props.articleLink} target="_blank">
        <BoxImage src={props.imageURL}></BoxImage>
        <Description>
          <Headline>{props.title}</Headline>
          <br/>
          <Author>By {props.author}</Author>
          <MiniText>{props.photoCredit}</MiniText>
        </Description>
      </CardLayout>
    </Container>
  );
}
